/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderOtherCharge.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/order-other-charge";

export class AutogenModelOrderOtherCharge<RowType extends ModelRow> extends Endpoint<RowType, RowOrderOtherChargeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderOtherCharge extends ModelRow<RowOrderOtherChargeFields> {
	constructor(values?: Partial<RowOrderOtherChargeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderOtherChargeFields {
	allow_inc_in_frt: string;
	amount: number;
	calc_method: string;
	charge_id: string;
	customer_id: string;
	customer_name: string;
	descr: string;
	driver_id: string;
	est_fuel_surcharge: string;
	id: string;
	incl_in_freight: string;
	order_id: string;
	rate: number;
	rate_id: number;
	stop_loc_name: string;
	stop_no: string;
	tli_uid: number;
	units: number;
}

